// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"WorkOrganizationName_inputWrapper__cmKcY","clearButton":"WorkOrganizationName_clearButton__ieJFz","errorText":"WorkOrganizationName_errorText__vhMIT"};